import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message } from 'antd';
import Filter from './components/Filter';
import List from './components/List';
import TokenActionOrPlanModal from './components/TokenActionOrPlanModal';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SideNav from '../SideNav';
import Update from './components/Update';
import { saveParams } from '../../../actions/noticeActions';

class ComplaintRegistrationForm extends Component {
    static childContextTypes = {
        configure: PropTypes.object,
        systemDate: PropTypes.string
    }

    constructor(props) {
        super(props);
        const { params } = props;
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
            },
            searchParams: {...params},
            data: [],
            business: [],
            area: [],
            configure: {},
            loading: false,
            type: undefined,
            record: {},
            systemDate: undefined,
        };
    }

    getChildContext = () => {
        const { configure, systemDate } = this.state;
        return {
            configure,
            systemDate,
        };
    }

    componentDidMount() {
        this.queryWithLevelByParams();
        this.queryArea();
        this.queryConfigure();
        this.loadData();
        this.queryDate();
    }

    componentWillUnmount() {
        this.props.saveParams({ complaintRecordNumber: undefined });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, {
                typeName: 'LINE_OF_BUSINESS'
            }).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ business: res.typeConfigureList || [] });
        });
    }

    queryArea = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea)
            .then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ area: res.data });
        });
    }

    queryConfigure = () => {
        dictCache.getDict('COMPLAINT_CONFIG', cb => {
            Fetch.post(API_URL.qualityManagement.queryConfigureList)
            .then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            this.setState({ configure: res });
        });
    }

    queryDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate)
            .then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const { date } = res;
            this.setState({ systemDate: date });
        });
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        Fetch.post(API_URL.qualityManagement.queryComplaintRecord, {
            offset: current,
            limit: pageSize,
            ...searchParams,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    handleSearch = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    handleExport = () => {
        const { pagination, searchParams } = this.state;
        ExportUtil.export(searchParams, pagination, API_URL.qualityManagement.exportComplaintRecord);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    update = (type, record) => {
        this.setState({
            type,
            record,
        }, () => {
            !type && this.loadData();
        });
    }

    remove = (complaintRecordId) => {
        this.setState({ loading: true });
        Fetch.post(API_URL.qualityManagement.delComplaintRecord, {
            complaintRecordId,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.setState({ loading: false }, () => {
                this.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    download = (complaintRecordId) => {
        ExportUtil.export({ complaintRecordId }, null, API_URL.qualityManagement.exportComplaintRecordWord);
    }

    showToken = (record) => {
        this.tokenRef.show(record);
    }

    render() {
        const { business, area, searchParams, data, loading, pagination, type, record } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="complaintRegistrationForm" />
                {
                    !type ?
                        <div className="main">
                            <Filter
                                area={area}
                                business={business}
                                searchParams={searchParams}
                                update={this.update}
                                onSearch={this.handleSearch}
                                onExport={this.handleExport}
                                onChange={this.handleFilterChange}
                            />
                            <List
                                data={data}
                                loading={loading}
                                pagination={pagination}
                                update={this.update}
                                remove={this.remove}
                                download={this.download}
                                showToken={this.showToken}
                                onChange={this.handleTableChange}
                            />
                        </div>
                    :
                        <div className="main">
                            <Update
                                type={type}
                                record={record}
                                update={this.update}
                            />
                        </div>
                }
                <TokenActionOrPlanModal ref={el => this.tokenRef = el} />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintRegistrationForm);


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/index.js